// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chip-list[data-v-530da50e] .v-chip.active{background-color:#d9fdf5!important;border:1px solid #3df4cb!important}.chip-list[data-v-530da50e] .v-chip:not(.active){background-color:#ffe7ea!important;border:1px solid #ff6376!important}", ""]);
// Exports
module.exports = exports;
